import {createPerformanceDebugTrace, type PerformanceDebugData} from "@pg-mono/performance-debug";

export const CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP = "cloudflare_turnstile";
export const KM_PROTECTED_FORMS_PERFORMANCE_GROUP = "km_protected_forms";

export const createKmProtectedFormsPerformanceDebugTrace = (flow: string, initialData?: PerformanceDebugData) =>
    createPerformanceDebugTrace(flow, initialData, {group: KM_PROTECTED_FORMS_PERFORMANCE_GROUP});
import {createPerformanceDebugTrace, type PerformanceDebugData} from "@pg-mono/performance-debug";

export const CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP = "cloudflare_turnstile";
export const KM_PROTECTED_FORMS_PERFORMANCE_GROUP = "km_protected_forms";

export const createKmProtectedFormsPerformanceDebugTrace = (flow: string, initialData?: PerformanceDebugData) =>
    createPerformanceDebugTrace(flow, initialData, {group: KM_PROTECTED_FORMS_PERFORMANCE_GROUP});
